import {
    AnalyticsRequest,
    GroupBy,
    Metric,
    Sort,
} from '../../PanelTemplatesTheme/PanelTemplatesTheme';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultWidgetPosition } from '../../PanelTemplatesTheme/constants';
import ListeningMetrics from '@sprinklr/stories-services/AnalyticsService/ListeningMetrics';

export const HyperSpaceDualAxisChart: Widget = {
    type: 'hyperSpaceDualAxisChart',
    id: 'hyper-space-dual-axis-chart',
    name: 'Dual Axis',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        new AnalyticsRequest({
            limit: 2000,
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.day },
                    INBOUND_MESSAGE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'snCTm',
                    },
                    PLATFORM: { source: ListeningDimensions.day, dimensionName: 'date' },
                    BENCHMARKING: { source: ListeningDimensions.day, dimensionName: 'date' },
                    PAID: {
                        source: ListeningDimensions.day,
                        dimensionName: 'measurementTime',
                    },
                    ADVOCACY: { source: ListeningDimensions.day, dimensionName: 'date' },
                    RDB_FIREHOSE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'SN_CREATED_TIME',
                    },
                    STORY_MESSAGE: {
                        source: ListeningDimensions.day,
                        dimensionName: 'CREATED_TIME',
                    },
                    SPR_TASK: {
                        source: ListeningDimensions.day,
                        dimensionName: 'date',
                    },
                    COMMUNITY: {
                        source: ListeningDimensions.activityDate,
                        dimensionName: 'date',
                    },
                    SAM: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    AUDIENCE_ACTIVITY: {
                        source: ListeningDimensions.account,
                        dimensionName: 'ACCOUNT_ID',
                    },
                    OUTBOUND_MESSAGE: {
                        source: ListeningDimensions.account,
                    },
                    CONSUMPTION: {
                        source: ListeningDimensions.dayOfWeek,
                    },
                }),
            ],
            projections: [
                new Metric({
                    LISTENING: { source: ListeningMetrics.mentions },
                    INBOUND_MESSAGE: { dimensionName: 'OUTBOUND_COUNT' },
                    PLATFORM: { dimensionName: 'ENGAGEMENT_RATE' },
                    BENCHMARKING: { dimensionName: 'ENGAGEMENT_RATE' },
                    PAID: { dimensionName: 'impressions' },
                    ADVOCACY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_COUNT',
                        heading: 'Activity_Count',
                    },
                    RDB_FIREHOSE: {
                        dimensionName: 'REACH_COUNT',
                        heading: 'Reach',
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'WEB_REACH',
                        heading: 'Web_Reach',
                    },
                    SPR_TASK: {
                        dimensionName: 'DOC_COUNT',
                        heading: 'Task Count',
                    },
                    COMMUNITY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_COUNT',
                        heading: 'Activity Count',
                    },
                    SAM: {
                        dimensionName: 'TOTAL_ENGAGEMENT',
                        heading: 'Total Engagement',
                    },
                    AUDIENCE_ACTIVITY: {
                        dimensionName: 'AUDIENCE_ACTIVITY_COUNT',
                        heading: 'Activity Count',
                    },
                    OUTBOUND_MESSAGE: {
                        dimensionName: 'TOTAL_ENGAGEMENT',
                        heading: 'Total Engagement',
                    },
                    CONSUMPTION: {
                        dimensionName: 'ACTIVITY_COUNT',
                        heading: 'Activity Count',
                    },
                }),
                new Metric({
                    LISTENING: { source: ListeningMetrics.reach },
                    INBOUND_MESSAGE: { dimensionName: 'INBOUND_COUNT' },
                    PLATFORM: { dimensionName: 'TOTAL_ENGAGEMENT' },
                    BENCHMARKING: { dimensionName: 'TOTAL_ENGAGEMENT' },
                    PAID: { dimensionName: 'spent' },
                    ADVOCACY: { dimensionName: 'POINTS' },
                    RDB_FIREHOSE: {
                        dimensionName: 'MENTIONS_COUNT',
                        heading: 'Mentions',
                    },
                    STORY_MESSAGE: {
                        dimensionName: 'IMPACT',
                        heading: 'Web_Impact',
                        aggregateFunction: 'AVG',
                    },
                    SPR_TASK: {
                        dimensionName: 'COMPLETION_DATE_SLA',
                        heading: 'Task Completion SLA',
                    },
                    COMMUNITY: {
                        dimensionName: 'Unique_User_Count',
                        heading: 'Unique User Count',
                    },
                    SAM: {
                        dimensionName: 'reportingStats.COMMENTS',
                        heading: 'Comments (DAM)',
                    },
                    AUDIENCE_ACTIVITY: {
                        dimensionName: 'LIKE_ACTIVITY_COUNT',
                        heading: 'Like Activity Count',
                    },
                    OUTBOUND_MESSAGE: {
                        dimensionName: 'REACH',
                        heading: 'Reach',
                    },
                    CONSUMPTION: {
                        dimensionName: 'USER_LOGGED_IN_COUNT',
                        heading: 'User Logged In Count',
                    },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Dual Axis Chart',
        size: WIDGET_LABEL_SIZE.primary,
        enabled: false,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        baseXYChartOptions: {
            grid: {
                enabled: false,
            },
            xAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
            yAxis: {
                ticks: {
                    formats: {
                        numberFormat: {
                            decimals: 0,
                            useShortened: true,
                        },
                        dateFormat: {
                            autoFormat: true,
                            formatString: 'dd MMM',
                        },
                    },
                    //TODO: how should we actually handle this
                    numTicks: 5,
                },
                enabled: true,
                label: {
                    enabled: true,
                    size: 50,
                },
                line: {
                    enabled: false,
                    stroke: '',
                    strokeWidth: 1,
                },
            },
        },
        zeroFill: true,
        legend: {
            enabled: true,
            position: {
                auto: true,
                selectedPosition: 'top',
            },
        },
    },
};
